import React from 'react'
import { IProps as ILogoProps } from 'marketing-site/src/library/elements/Logo'
import {
  ILogoCarousel as IContentfulLogoCarousel,
  ILogo as IContentfulLogo,
} from 'marketing-site/@types/generated/contentful'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import { camelCase } from 'lodash'
import {
  LogoCarousel,
  IProps as ILogoCarouselProps,
} from 'marketing-site/src/mvp-v2/library/components/LogoCarousel'

export const ContentfulLogoCarousel = (
  logoCarousel: IContentfulLogoCarousel,
): React.ReactElement => {
  return (
    <EntryMarker entry={logoCarousel}>
      {() => <LogoCarousel {...transformWiredCardsMvp(logoCarousel)} />}
    </EntryMarker>
  )
}

export function transformLogo({ fields }: IContentfulLogo): ILogoProps {
  return {
    ...fields,
    logoUrl: fields.logoUrl.fields.file.url,
  }
}

export function transformWiredCardsMvp({ fields }: IContentfulLogoCarousel): ILogoCarouselProps {
  return {
    ...fields,
    logos: fields.logos.map(transformLogo),
    backgroundColor:
      fields.backgroundColor &&
      (camelCase(fields.backgroundColor) as ILogoCarouselProps['backgroundColor']),
  }
}
